/**
 * Two-way sticky column for [data-sticky-column] (desktop, >= 48rem).
 * A sticky element taller than the viewport would hide its end, so this adjusts
 * its `top` as the page scrolls: scrolling down it travels with the page until its
 * bottom is visible, then sticks; scrolling up it travels back until its top is
 * visible, then sticks under the header. Height changes (opening a panel, swapping
 * a variant) keep the current position. Smaller columns simply stick at the offset.
 */
const desktop = window.matchMedia('(min-width: 48rem)');

for (const column of document.querySelectorAll('[data-sticky-column]')) {
  const offset = Number(column.dataset.stickyOffset) || 0;
  const gap = 24;
  let top = offset;
  let lastY = window.scrollY;
  let frame = 0;

  const update = () => {
    frame = 0;
    const y = window.scrollY;
    const delta = y - lastY;
    lastY = y;
    if (!desktop.matches) {
      column.style.removeProperty('top');
      return;
    }
    const minTop = Math.min(offset, window.innerHeight - column.offsetHeight - gap);
    top = Math.max(minTop, Math.min(offset, top - delta));
    column.style.top = `${Math.round(top)}px`;
  };

  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(update);
  };

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  desktop.addEventListener('change', schedule);
  new ResizeObserver(schedule).observe(column);
  update();
}
